/*
 * Home Hero Entry Point
 * Loaded only when [home_hero] shortcode is used.
 */

import * as THREE from 'three';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Globals must be set before dynamic imports execute the IIFEs
window.THREE = THREE;
gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// DOM adapter runs as static import: maps WP block classes → claude design selectors
// (does not depend on THREE/gsap so the ordering doesn't matter for it)
import './home/home-dom-init.js';

// Chain ensures each IIFE has its dependencies ready before running
import('./home/hero3d.js')
  .then(() => import('./home/image-slot.js'))
  .then(() => import('./home/scroll.js'));
